var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_240_467)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.5051 4.64761C33.6768 4.64761 27.0018 6.67248 21.3242 10.4662C15.6467 14.2598 11.2216 19.6519 8.60851 25.9606C5.99543 32.2692 5.31173 39.2111 6.64386 45.9083C7.976 52.6055 11.2642 58.7573 16.0925 63.5857C20.9209 68.4142 27.0725 71.7024 33.7697 73.0345C40.4668 74.3667 47.4085 73.683 53.7171 71.0699C60.0256 68.4567 65.4176 64.0315 69.2112 58.3539C73.0048 52.6763 75.0297 46.0012 75.0297 39.1728C75.0297 30.0161 71.3923 21.2345 64.9176 14.7598C58.443 8.28507 49.6616 4.64761 40.5051 4.64761V4.64761ZM51.4812 56.9665C51.3521 57.2887 51.1555 57.5796 50.9047 57.8197C50.6539 58.0597 50.3547 58.2433 50.0271 58.3583C49.6995 58.4732 49.3511 58.5168 49.0054 58.4861C48.6596 58.4554 48.3243 58.3511 48.0221 58.1802L38.654 50.8914L32.6348 56.4353C32.4951 56.5382 32.3317 56.6043 32.1598 56.6275C31.9878 56.6507 31.8128 56.6303 31.6508 56.5681L32.8034 46.2504L32.8406 46.2796L32.8645 46.0765C32.8645 46.0765 49.7285 30.7221 50.4163 30.0674C51.1041 29.4128 50.8824 29.2707 50.8824 29.2707C50.9222 28.474 49.6342 29.2707 49.6342 29.2707L27.2888 43.6571L17.9831 40.4874C17.9831 40.4874 16.5543 39.9695 16.4189 38.8474C16.2834 37.7254 18.0296 37.1212 18.0296 37.1212L55.0293 22.4228C55.0293 22.4228 58.0714 21.067 58.0714 23.3124L51.4812 56.9665Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_240_467",
    x: 2.98047,
    y: 2.64761,
    width: 75.0488,
    height: 75.0503,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_240_467"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_240_467",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.615aefaba8a61cfbed55c09836f952f2.svg";
export { ForwardRef as ReactComponent };